import { render } from "./ProductUpdates.vue?vue&type=template&id=1859d6e2"
import script from "./ProductUpdates.vue?vue&type=script&lang=js"
export * from "./ProductUpdates.vue?vue&type=script&lang=js"
script.render = render

export default script